import React from 'react';
import { Dialog, DialogContent } from '../../components/ui/dialog';
import NewImport from '../../pages/dashboard/imports-new/NewImport';

interface ImportModalProps {
  open: boolean;
  onClose: () => void;
}

const ImportModal: React.FC<ImportModalProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full h-[80vh] overflow-hidden p-0">
        <div className="h-full">
          <NewImport />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportModal; 